// extracted by mini-css-extract-plugin
export var container = "_bd-0";
export var outlet = "_bd-1";
export var outletEnter = "_bd-2";
export var outletEnterActive = "_bd-3";
export var outletExit = "_bd-4";
export var outletExitActive = "_bd-5";